<div class="material-datatables">
  <table
    [id]="table_id"
    class="table table-striped table-no-bordered table-hover"
    cellspacing="0"
    width="100%"
    style="width: 100%"
  >
    <thead>
      <tr>
        <th class="order" (click)="sort('id')">
          <i
            [ngStyle]="{ color: orderby === 'id' ? 'blue' : 'black' }"
            class="fa {{ sorting('id') }}"
          ></i>
          &nbsp; <b>Id</b>
        </th>
        <th class="order" (click)="sort('po')">
          <i
            [ngStyle]="{ color: orderby === 'po' ? 'blue' : 'black' }"
            class="fa {{ sorting('po') }}"
          ></i>
          &nbsp; <b>PO #</b>
        </th>
        <th class="order" (click)="sort('rep')">
          <i
            [ngStyle]="{ color: orderby === 'rep' ? 'blue' : 'black' }"
            class="fa {{ sorting('rep') }}"
          ></i>
          &nbsp; <b>Requested By</b>
        </th>
        <th class="order" (click)="sort('type')">
          <i
            [ngStyle]="{ color: orderby === 'type' ? 'blue' : 'black' }"
            class="fa {{ sorting('type') }}"
          ></i>
          &nbsp; <b>Type</b>
        </th>
        <th class="order" (click)="sort('deadline')">
          <i
            [ngStyle]="{ color: orderby === 'deadline' ? 'blue' : 'black' }"
            class="fa {{ sorting('deadline') }}"
          ></i>
          &nbsp; <b>Deadline</b>
        </th>
        <th class="order" (click)="sort('createdat')">
          <i
            [ngStyle]="{ color: orderby === 'createdat' ? 'blue' : 'black' }"
            class="fa {{ sorting('createdat') }}"
          ></i>
          &nbsp; <b>Request Date</b>
        </th>
        <th class="order" (click)="sort('numitems')">
          <i
            [ngStyle]="{ color: orderby === 'numitems' ? 'blue' : 'black' }"
            class="fa {{ sorting('numitems') }}"
          ></i>
          &nbsp; <b># Of Items</b>
        </th>
        <th class="order" (click)="sort('askedlocation')">
          <i
            [ngStyle]="{
              color: orderby === 'askedlocation' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('askedlocation') }}"
          ></i>
          &nbsp; <b>Destination</b>
        </th>
        <th class="order" (click)="sort('tousersdata')">
          <i
            [ngStyle]="{ color: orderby === 'tousersdata' ? 'blue' : 'black' }"
            class="fa {{ sorting('tousersdata') }}"
          ></i>
          &nbsp; <b>Assigned to</b>
        </th>
        <th class="order" (click)="sort('containers')">
          <i
            [ngStyle]="{ color: orderby === 'containers' ? 'blue' : 'black' }"
            class="fa {{ sorting('containers') }}"
          ></i>
          &nbsp; <b>Pending Containers</b>
        </th>
        <th class="order" (click)="sort('containersDone')">
          <i
            [ngStyle]="{
              color: orderby === 'containersDone' ? 'blue' : 'black'
            }"
            class="fa {{ sorting('containersDone') }}"
          ></i>
          &nbsp; <b>Delivered Containers</b>
        </th>
        <th class="order" (click)="sort('status')">
          <i
            [ngStyle]="{ color: orderby === 'status' ? 'blue' : 'black' }"
            class="fa {{ sorting('status') }}"
          ></i>
          &nbsp; <b>Status</b>
        </th>
        <th class="text-right"><b>Actions</b></th>
      </tr>
    </thead>
    <tbody>
      <tr
        style="cursor: pointer"
        *ngFor="let item of data2; let j = index"
        (click)="unclick(j, item)"
        (dblclick)="saveEmit('show', item.id)"
        [ngClass]="{ 'bg-lumin': selectrow === j }"
      >
        <td>{{ item.id }}</td>
        <td>{{ item.po.po }}</td>
        <td>{{ item.rep.name }} {{ item.rep.surname }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.deadline }}</td>
        <td>{{ item.createdAt | date : "MM-dd-yyyy h:mm:ss" }}</td>
        <td>{{ item.numItems }}</td>
        <td>
          {{
            item.askedLocation !== null
              ? item.askedLocation.location
                ? item.askedLocation.location.name +
                  " - " +
                  item.askedLocation.locationName
                : ""
              : ""
          }}
        </td>
        <td>{{ item.toUsersData }}</td>
        <td>
          <span
            *ngFor="let container of item.containers; let i = index"
            (mouseover)="cont(container)"
            [matTooltip]="tablaDinamicaSet ? wh : null"
            data-toggle="tooltip"
            [title]="wh"
            class="tool tooltipmanual toolverificar"
            [attr.data-attr]="container"
            (click)="openlink(container)"
          >
            {{ container
            }}<span
              style="padding: 0"
              *ngIf="
                item.containers.length > 1 && i < item.containers.length - 1
              "
              >,</span
            >
            <span [attr.data-interno]="container" class="tooltiptext"
              >Please wait...</span
            >
          </span>
        </td>
        <td>
          <span
            *ngFor="let container of item.containersDone; let i = index"
            (mouseover)="cont(container)"
            [matTooltip]="tablaDinamicaSet ? wh : null"
            data-toggle="tooltip"
            [title]="wh"
            class="tool tooltipmanual toolverificar"
            [attr.data-attr]="container"
            (click)="openlink(container)"
          >
            {{ container
            }}<span
              style="padding: 0"
              *ngIf="
                item.containersDone.length > 1 &&
                i < item.containersDone.length - 1
              "
              >,</span
            >
            <span [attr.data-interno]="container" class="tooltiptext"
              >Please wait...</span
            >
          </span>
        </td>
        <td>
          <button
            *ngIf="item.status === 'pending'"
            class="btn btn-sm btn-warning"
          >
            Pending
          </button>
          <button
            *ngIf="item.status === 'received'"
            class="btn btn-sm btn-info"
          >
            Delivered
          </button>
          <button
            *ngIf="item.status === 'COMPLETED'"
            class="btn btn-sm btn-success"
          >
            Completed
          </button>
        </td>
        <td style="text-align: right">
          <a
            *ngIf="item.numchats === 1"
            class="btn btn-link btn-warning btn-just-icon"
          >
            <i class="material-icons">question_answer</i>
          </a>

          <!-- <a *ngIf="item.chatLogs" class="btn btn-link btn-warning btn-just-icon" (click)="saveEmit('chat',item.id, item)">
            <i class="material-icons">chat_bubble</i>
          </a> -->

          <a class="btn btn-link btn-info btn-just-icon">
            <i class="material-icons emitir" id="show-{{ item.id }}"
              >remove_red_eye</i
            >
          </a>

          <!-- <a class="btn btn-link btn-dark btn-just-icon" (click)="saveEmit('print',item.id, item)">
            <i class="material-icons">local_printshop</i>
          </a> -->

          <a
            class="btn btn-link btn-danger btn-just-icon"
            *ngIf="item.status == 'pending'"
          >
            <i class="material-icons emitir" id="delete-{{ item.id }}">close</i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<style>
  .order {
    cursor: pointer;
  }
</style>
